<script lang="ts">
  import type { Paginated } from '@feathersjs/feathers'
  import { t } from 'svelte-i18n'
  import { fade } from 'svelte/transition'
  import ColumnAction from '../../app-components/ColumnAction.svelte'
  import Button from '../../components/button/Button.svelte'
  import type { IColumn } from '../../components/datatable/Datatable.svelte'
  import Datatable from '../../components/datatable/Datatable.svelte'
  import Dialog from '../../components/dialog/Dialog.svelte'
  import Fab from '../../components/fab/Fab.svelte'
  import feathers from '../../lib/feathers'
  import type { ICategory } from '../../lib/types'
  import { darkModeStore } from '../../stores/darkMode.store'
  import { paginationLimitStore } from '../../stores/paginationLimit.store'
  import { restaurantIdStore } from '../../stores/restaurantId.store'

  let categories: Paginated<ICategory>
  $: limit = $paginationLimitStore
  let page = 1
  let sort = { order: 1, key: 'name' }

  let deleteError: string | undefined = undefined
  function closeErrorModal() {
    deleteError = undefined
  }

  $: columns = [
    { key: 'name', header: $t('columns.name'), sortable: true },
    { key: 'order', header: $t('columns.order'), sortable: true, defaultValue: '' },
    {
      key: '',
      header: '',
      sortable: false,
      width: '100px',
      component: ColumnAction,
      componentProps: (line: ICategory) => ({
        editHref: `/categories/${line._id}`,
        deleteModalTitle: $t('form.ask_delete_$name', { values: { name: line?.name || '' } }),
        onDelete: async () => {
          try {
            await feathers.service('categories').remove(line._id, {
              query: {
                restaurantId: $restaurantIdStore,
              },
            })
            categories = await fetchData()
          } catch (error) {
            const message = error.message
            if (message && typeof message === 'string') {
              deleteError = message
            }
            console.log('Failed to remove', error)
          }
        },
      }),
    },
  ] as IColumn[]

  $: fetchData = async () => {
    return feathers.service('categories').find({
      query: {
        restaurantId: $restaurantIdStore,
        $sort: { [sort.key]: [sort.order] },
        $limit: limit,
        $skip: (page - 1) * limit,
      },
    }) as Promise<Paginated<ICategory>>
  }

  $: {
    fetchData().then((data) => (categories = data))
  }
</script>

{#if categories}
  <div in:fade>
    {#if !categories?.total}
      <h3>{$t('help.category_empty')}</h3>
      <Button href="/categories/nouveau" label={$t('begin')} variant="contained" />
    {:else}
      <Datatable
        bind:page
        bind:limit={$paginationLimitStore}
        bind:sort
        data={categories.data}
        columns={columns}
        total={categories.total}
        buttonsColor={$darkModeStore ? 'primary' : 'default'}
        largeRow
        paginationText={$t('lines_per_page')}
      />
    {/if}
  </div>
{/if}

{#if deleteError}
  <Dialog title={$t('error')} content={deleteError} on:close={closeErrorModal}>
    <div slot="actions">
      <Button label={$t('ok')} on:click={closeErrorModal} primary={!!$darkModeStore} />
    </div>
  </Dialog>
{/if}

<style>
</style>
